import React from 'react'
import ReactDOM from 'react-dom'
import init from './config'
import CobaltRoot from '@cobalt/cobalt-react-components'
import Root from './root'
import { initializeApplication } from './actions/initialization'
import '../assets/stylesheet.css'
import context from './config/context'
import { initTDFeatures } from './config/feature-flags'
import { ErrorBoundary } from 'react-error-boundary'

window.TalkdeskApps = window.TalkdeskApps || {}

window.TalkdeskApps.TalkdeskId = {
  start: function(rootElement, params) {
    initContext(params)
    CobaltRoot.loadBundle()

    startApp(rootElement, params)
  },
  stop: function(rootElement) {
    ReactDOM.unmountComponentAtNode(rootElement)
  },
  version: __APP_VERSION__
}

// TODO: Deprecate after TD-ID sets the keys in the document.context
const initContext = ({
  brandAssetsURL,
  talkdeskIdAssetsURL,
  csrfToken,
  tenantId,
  splitIoKeyUI,
  passwordPolicies,
  showGoogleFooterLink
}) =>
  Object.assign(context, {
    brandAssetsURL: brandAssetsURL || context.brandAssetsURL,
    talkdeskIdAssetsURL: talkdeskIdAssetsURL || context.talkdeskIdAssetsURL,
    csrfToken: csrfToken.token || context.csrfToken,
    tenantId: tenantId || context.tenantId,
    splitIoKeyUI: splitIoKeyUI || context.splitIoKeyUI,
    passwordPolicies: passwordPolicies || context.passwordPolicies,
    showGoogleFooterLink: showGoogleFooterLink || context.showGoogleFooterLink
  })

async function startApp(rootElement, { ...params }) {
  const { user, siteKey } = params

  const { store, history } = init()

  store.dispatch(
    initializeApplication({
      user,
      siteKey
    })
  )

  await initTDFeatures()

  ReactDOM.render(
    <ErrorBoundary
      onError={error =>
        // eslint-disable-next-line no-console
        console.log(`Error name: ${error.name}, message: ${error.message}`)
      }
    >
      <CobaltRoot>
        <Root store={store} history={history} />
      </CobaltRoot>
    </ErrorBoundary>,
    rootElement
  )
}

if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render')
  whyDidYouRender(React, {
    trackAllPureComponents: true
  })
}
